<template>
  <Head :title="t('page.title', {institution: institution.abbreviation})" />
  <s-page-block>
    <s-page-header :heading="t('header.heading')" class="mb-3" />
    <s-tabs
      v-model="currentTab"
      :tabs="[{label: t('tabs.brightspace')}, {label: t('tabs.canvas')}]"
    >
      <template #tab-0-content>
        <brightspace-instructions :institution-id="institution.id" />
      </template>
      <template #tab-1-content>
        <canvas-instructions :institution-id="institution.id" />
      </template>
    </s-tabs>
  </s-page-block>
</template>
<script setup lang="ts">
import {Head} from '@inertiajs/vue3';
import {route} from 'ziggy-js';
import {useI18n} from 'vue-i18n';
import SPageBlock from '../../design-system/SPageBlock.vue';
import SPageHeader from '../../design-system/SPageHeader.vue';
import {Institution} from '../../types/entities/institution.js';
import {ref} from 'vue';
import BrightspaceInstructions from './Instructions/BrightspaceInstructions.vue';
import CanvasInstructions from './Instructions/CanvasInstructions.vue';
import STabs from '../../design-system/STabs.vue';
import {usePageParams} from '../../composables/usePageParams.js';

defineProps<{
  institution: Institution;
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const currentTab = ref(0);
</script>
<i18n>
{
  "en": {
    "page.title": "Registration Instructions - LTI - {institution}",
    "header.heading": "LTI Registration Instructions",
    "tabs.brightspace": "Brightspace",
    "tabs.canvas": "Canvas"
  },
  "fr": {
    "page.title": "Instructions d'enregistrement - LTI - {institution}",
    "header.heading": "Instructions d'enregistrement LTI",
    "tabs.brightspace": "Brightspace",
    "tabs.canvas": "Canvas"
  }
}
</i18n>
